module.exports = __webpack_public_path__ + "media/images/icons/flags/PS-83538ac92ed6c585197a28a4920783a7.svg";